import React from "react";
import { Card, CardContent } from "../ui/card";

export function SupportModule({ t, isMobile }) {
  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
      
      {/* Support Header */}
      <Card className="panel lightCard" style={{marginTop: 8}}>
        <CardContent>
          <div className="panel-title darktxt">🎧 {t('support_title')}</div>
          <div className="small">{t('support_subtitle')}</div>
        </CardContent>
      </Card>

      {/* Chatbot iframe */}
      <Card className="panel lightCard">
        <CardContent style={{padding: 0}}>
          <iframe
            src="https://www.chatbase.co/chatbot-iframe/SgA1C2aQ2CAWNWeWwzv7r"
            style={{
              width: '100%',
              height: isMobile ? '500px' : '600px',
              border: 'none',
              borderRadius: '8px'
            }}
            title="Support Chatbot"
            allow="microphone"
          />
        </CardContent>
      </Card>

    </div>
  );
}
